export const microdatasSocials = {
  DE: [
    'https://www.facebook.com/vestiaireco',
    'https://twitter.com/vestiaireco',
    'https://de.linkedin.com/company/vestiaireco',
    'https://fr.wikipedia.org/wiki/Vestiaire_Collective',
    'https://www.instagram.com/vestiaireco/',
    'https://www.youtube.com/user/VestiaireCollective',
    'https://www.pinterest.de/vestiaireco/'
  ],
  EN: [
    'https://www.facebook.com/vestiaireco',
    'https://twitter.com/vestiaireco',
    'https://www.linkedin.com/company/vestiaireco',
    'https://fr.wikipedia.org/wiki/Vestiaire_Collective',
    'https://www.instagram.com/vestiaireco/',
    'https://www.youtube.com/user/VestiaireCollective',
    'https://www.pinterest.com/vestiaireco/'
  ],
  UK: [
    'https://www.facebook.com/vestiaireco',
    'https://twitter.com/vestiaireco',
    'https://www.linkedin.com/company/vestiaireco',
    'https://fr.wikipedia.org/wiki/Vestiaire_Collective',
    'https://www.instagram.com/vestiaireco/',
    'https://www.youtube.com/user/VestiaireCollective',
    'https://www.pinterest.com/vestiaireco/'
  ],
  ES: [
    'https://www.facebook.com/vestiaireco',
    'https://twitter.com/vestiaireco',
    'https://www.linkedin.com/company/vestiaireco',
    'https://fr.wikipedia.org/wiki/Vestiaire_Collective',
    'https://www.instagram.com/vestiaireco/',
    'https://www.youtube.com/user/VestiaireCollective',
    'https://www.pinterest.es/vestiaireco/'
  ],
  FR: [
    'https://www.facebook.com/vestiaireco',
    'https://twitter.com/vestiaireco_fr',
    'https://fr.linkedin.com/company/vestiaireco',
    'https://fr.wikipedia.org/wiki/Vestiaire_Collective',
    'https://www.instagram.com/vestiaireco/',
    'https://www.youtube.com/user/VestiaireCollective',
    'https://www.pinterest.fr/vestiaireco/'
  ],
  IT: [
    'https://www.facebook.com/vestiaireco',
    'https://twitter.com/vestiaireco',
    'https://www.linkedin.com/company/vestiaireco',
    'https://fr.wikipedia.org/wiki/Vestiaire_Collective',
    'https://www.instagram.com/vestiaireco/',
    'https://www.youtube.com/user/VestiaireCollective',
    'https://www.pinterest.it/vestiaireco/'
  ],
  US: [
    'https://www.facebook.com/vestiaireco',
    'https://twitter.com/vestiaireco',
    'https://www.linkedin.com/company/vestiaireco',
    'https://fr.wikipedia.org/wiki/Vestiaire_Collective',
    'https://www.instagram.com/vestiaireco/',
    'https://www.youtube.com/user/VestiaireCollective',
    'https://www.pinterest.com/vestiaireco/'
  ],
  WW: [
    'https://www.facebook.com/vestiaireco',
    'https://twitter.com/vestiaireco',
    'https://www.linkedin.com/company/vestiaireco',
    'https://fr.wikipedia.org/wiki/Vestiaire_Collective',
    'https://www.instagram.com/vestiaireco/',
    'https://www.youtube.com/user/VestiaireCollective',
    'https://www.pinterest.com/vestiaireco/'
  ]
};
